import type { AdditionalItem } from '@/hooks';
import { useInputAndInputBase } from './useInputAndInputBase';

interface UseInputAndInputPartialProps {
	additionalItem: AdditionalItem;
}

interface UseInputAndInputPartialReturn {
	formFieldName: string[];
	localAdditionalItem: AdditionalItem;
	worstRisk: number;
	isAddValueOneDisabled: boolean;
	isAddValueTwoDisabled: boolean;
	isCalculatingScore: boolean;
	handleAddValueOneClick: () => Promise<void>;
	handleAddValueTwoClick: () => Promise<void>;
	handleRemoveAdditionalItemClick: (removedId: string) => void;
}

export function useInputAndInputPartial({
	additionalItem
}: Readonly<UseInputAndInputPartialProps>): UseInputAndInputPartialReturn {
	const {
		id,
		formFieldName,
		formValueOne,
		formValueTwo,
		localAdditionalItem,
		worstRisk,
		isCalculatingScore,
		persistResultEntry,
		handleRemoveAdditionalItemClick
	} = useInputAndInputBase({ additionalItem });

	async function handleAddValueOneClick(): Promise<void> {
		const clearFieldName = [...formFieldName, 'additional_items', id, 'value_1'];

		await persistResultEntry({ value_1: formValueOne, value_2: undefined, clearFieldName });
	}

	async function handleAddValueTwoClick(): Promise<void> {
		const clearFieldName = [...formFieldName, 'additional_items', id, 'value_2'];

		await persistResultEntry({ value_1: undefined, value_2: formValueTwo, clearFieldName });
	}

	const isAddValueOneDisabled = isCalculatingScore || !formValueOne;
	const isAddValueTwoDisabled = isCalculatingScore || !formValueTwo;

	return {
		formFieldName,
		localAdditionalItem,
		worstRisk,
		isAddValueOneDisabled,
		isAddValueTwoDisabled,
		isCalculatingScore,
		handleAddValueOneClick,
		handleAddValueTwoClick,
		handleRemoveAdditionalItemClick
	};
}
